import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/layout/Layout";
import { DemoGateProvider } from "@/components/DemoGate";
import Home from "@/pages/Home";
import ServicesMenu from "@/pages/ServicesMenu";
import HairStudio from "@/pages/HairStudio";
import NailLounge from "@/pages/NailLounge";
import Esthetics from "@/pages/Esthetics";
import Waxing from "@/pages/Waxing";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Memberships from "@/pages/Memberships";
import Reviews from "@/pages/Reviews";
import FAQ from "@/pages/FAQ";
import Book from "@/pages/Book";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Accessibility from "@/pages/Accessibility";

function App() {
  return (
    <BrowserRouter>
      <DemoGateProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesMenu />} />
          <Route path="/hair-studio" element={<HairStudio />} />
          <Route path="/nail-lounge" element={<NailLounge />} />
          <Route path="/esthetics-facials" element={<Esthetics />} />
          <Route path="/waxing" element={<Waxing />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/memberships" element={<Memberships />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/book" element={<Book />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
      </DemoGateProvider>
      <Toaster position="bottom-right" theme="light" />
    </BrowserRouter>
  );
}

export default App;
